import React, { useState } from 'react';
import { Box, Image, Link, Spinner, Text } from '@chakra-ui/react';
import Button from '../Button';
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import FacebookIcon from '../../assets/facebook-icon.svg';
import LinkedinIcon from '../../assets/linkedin-icon.svg';
import PinterestIcon from '../../assets/pinterest-icon.svg';
import TwitterIcon from '../../assets/twitter-icon.svg';
import WhatsappIcon from '../../assets/whatsapp-icon.svg';
import CopyGreenIcon from '../../assets/copy-green-icon.svg';
import CopySuccessIcon from '../../assets/copy-success-icon.svg';

const NoDataComponent = (props) => {
  const {
    isFetching,
    icon,
    title,
    description,
    titleButton,
    shareUrl,
    media,
    iconButton,
    onClick,
    btnVariant,
    outlinedIcon
  } = props;

  const [isCopy, setIsCopy] = useState(false);

  const handleCopy = (value) => async () => {
    try {
      if (!isCopy) {
        setIsCopy(true);
        setTimeout(() => {
          setIsCopy(false);
        }, 3000);
        if (value) navigator.clipboard.writeText(value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return isFetching ? (
    <Box
      display={'flex'}
      height={'121px'}
      alignItems={'center'}
      justifyContent={'center'}
      w={'100%'}
    >
      <Spinner
        mx={'auto'}
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="dark-green"
        size={{ base: 'lg', '2xl': 'xl' }}
      />
    </Box>
  ) : (
    <div className="flex flex-col items-center gap-4 max-w-[636px]">
      {outlinedIcon
        ? icon && (
            <Box bg="green.50" p={1.5} borderRadius="full">
              <img src={icon} className="w-10 h-10" alt="" />
            </Box>
          )
        : icon && <img src={icon} className="w-12 h-12" alt="" />}

      <div className="flex flex-col gap-2 items-center text-center">
        <p className="text-lg font-[600]">{title}</p>
        <p>{description}</p>
      </div>
      {titleButton && (
        <Button variant={btnVariant} className="w-fit flex flex-row items-center" onClick={onClick}>
          <p>{titleButton}</p>
          {iconButton && <img src={iconButton} className="ml-2 w-3 h-3" alt="" />}
        </Button>
      )}
      {shareUrl && (
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-3">
            <p className="font-[600] text-sm text-black">Share:</p>
            <div className="flex items-center gap-3">
              <FacebookShareButton url={shareUrl} hashtag={'#twygs'}>
                <Image
                  _hover={{
                    opacity: 0.8
                  }}
                  src={FacebookIcon}
                  alt="icon"
                />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                title={
                  'For readers who seek knowledge beyond the outrage cycle - my latest on Twygs'
                }
              >
                <Image
                  _hover={{
                    opacity: 0.8
                  }}
                  src={TwitterIcon}
                  alt="icon"
                />
              </TwitterShareButton>
              <LinkedinShareButton url={shareUrl}>
                <Image
                  _hover={{
                    opacity: 0.8
                  }}
                  src={LinkedinIcon}
                  alt="icon"
                />
              </LinkedinShareButton>
              <WhatsappShareButton
                url={shareUrl}
                windowWidth={700}
                title={
                  'For readers who seek knowledge beyond the outrage cycle - my latest on Twygs'
                }
                windowHeight={600}
                separator=" "
              >
                <Image
                  _hover={{
                    opacity: 0.8
                  }}
                  src={WhatsappIcon}
                  alt="icon"
                />
              </WhatsappShareButton>
              <PinterestShareButton
                description="twygs.io"
                media={
                  media ||
                  `${process.env.REACT_APP_NEWSLETTER_URL}static/media/default-thumnail.ec3e32b29325b9a52a3c.png`
                }
                url={shareUrl}
              >
                <Image
                  _hover={{
                    opacity: 0.8
                  }}
                  src={PinterestIcon}
                  alt="icon"
                />
              </PinterestShareButton>
            </div>
          </div>
          <div className="p-2 mt-[10px] bg-05-seasalt-white rounded-[12px] flex items-center justify-between gap-4 w-full">
            <Link href={shareUrl} target="_blank">
              <Text
                isTruncated
                w={'100%'}
                maxW={{ base: '210px', md: '257px' }}
                fontSize={'sm'}
                fontWeight={600}
                color={'#012BC2'}
                _hover={{ cursor: 'pointer' }}
              >
                {shareUrl}
              </Text>
            </Link>
            <Box
              display={'flex'}
              alignItems={'center'}
              columnGap={'8px'}
              onClick={handleCopy(shareUrl)}
              cursor="pointer"
            >
              <Text fontSize={'sm'} fontWeight={900} color={'#4CAF50'}>
                {isCopy ? 'Copied' : 'Copy'}
              </Text>
              <Image src={isCopy ? CopySuccessIcon : CopyGreenIcon} alt="" />
            </Box>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoDataComponent;
